<div id="organizeCgu" class="form-step-modal modal fade"   role="dialog">
  <div class="modal-dialog custum-drop-modal modal-dialog-centered modal-lg" role="document">
    <div class="modal-content form-step-modal__content">
      <div class="modal-body form-crop-modal__body">
        <p [innerHTML]="event.general_conditions_text">{{event.general_conditions_text}}</p>
      </div>
    </div>
  </div>
</div>

<div *ngIf="order && event">
<div class="details-cmd">
  <div class="container">
    <header class="flexible" *ngIf="!insCriptionMode">
      <h5 class="inline-block text-uppercase">01. {{'front_booking_infos.summary'| translate}}</h5>
      <span>
        <a [routerLink]="['/event/'+event.id]" title="Changer" class="inline-block text-uppercase">
         <i class="fa fa-edit"></i>
        </a>
        <a href="javascript:void(0);" (click)="toggleRecap()"  title="Montrer/Cacher les détails" class="inline-block">
         <i class="fa" [ngClass]="{'fa-plus': !recapIsOpen, 'fa-minus': recapIsOpen}"></i>
        </a>
      </span>
    </header>
    <div class="table-wrapper" *ngIf="recapIsOpen && !insCriptionMode">
      <div class="width-100 table" >
        <div class="flexible table-row width-100">
          <div class="flexible width-100" style="background-color: #F4F2F3">
            <div class="column-header flexible title text-left">
              <span> </span>
              <span class="opacity-50"></span></div>
            <div class="column-header ft-size-13 recap-items flexible"><span class="price margin-auto" >{{'front_booking_infos.unit_price'| translate}}</span></div>
            <div class="column-header ft-size-13 recap-items flexible"><span class="price margin-auto">{{'front_booking_infos.quantity'| translate}}</span></div>
            <div class="column-header ft-size-13 recap-items flexible"><span class="price margin-auto" >{{'front_booking_infos.total_price'| translate}}</span></div>
          </div>
        </div>
        <div *ngFor="let pricing of pricings let idx=index" class="table-row flexible width-100">
          <!--<div class="column flexible index text-center" *ngIf="pricing.nbreTicket">{{idx}}</div>-->
          <div class="flexible width-100 border-bottom-1" *ngIf="pricing.nbreTicket>0">
            <div class="column flexible title text-left padding-10">
              <span>{{pricing.label }} </span>
              <span class="opacity-50"><!--({{dayname}},  {{day}} {{month}} à {{hours}}H)--><!--(Sun, 22 Jun 2014 at 08:45 AM)--></span>
            </div>
            <div class="column flexible recap-items" *ngIf="functionUtils.getPricingPrice(pricing) > 0">
              <span class="price margin-auto">
                <span>
                  {{functionUtils.getPricingPrice(pricing)}}{{functionUtils.getPricingDeviseSymbole(pricing.devise)}}
                </span>
                <span *ngIf="pricing.codePromo">{{' => '}}</span>
                <span *ngIf="pricing.codePromo">
                  {{functionUtils.calculatePricingPriceAfterPromoApply(pricing)}}{{functionUtils.getPricingDeviseSymbole(pricing.devise)}}
                </span>

              </span>
            </div>
            <div class="column flexible recap-items" *ngIf="functionUtils.getPricingPrice(pricing) === 0 "><span class="price margin-auto" >Gratuit</span></div>
            <div class="column flexible recap-items flexible"><span class="margin-auto">{{pricing.nbreTicket}}</span></div>
            <div class="column flexible recap-items" *ngIf="!pricing.open && functionUtils.getPricingPrice(pricing) > 0"><span class="price margin-auto">{{showPrice(pricing.nbreTicket * functionUtils.getPricingPrice(pricing) - functionUtils.pricingReduction(pricing)) + ' ' + showCurrency(functionUtils.getPricingDeviseSymbole(pricing.devise),pricing.nbreTicket * functionUtils.getPricingPrice(pricing) - functionUtils.pricingReduction(pricing))}}</span></div>
            <div class="column flexible recap-items" *ngIf="!pricing.open && functionUtils.getPricingPrice(pricing) == 0"><span class="price margin-auto">Gratuit</span></div>
            <div class="column flexible recap-items" *ngIf="pricing.open"><span class="price margin-auto">{{ functionUtils.getPricingTotal(pricing) +' '+functionUtils.getPricingDeviseSymbole(pricing.devise)}}</span></div>
          </div>
        </div>

        <div class="flexible width-100 toto mt-10">
          <div class="flexible width-100">
            <div class="column flexible text-right width-100">
              <div class="total-title ft-16">{{'front_booking_infos.subtotal'| translate}}</div>
              <span class="price-2 width-10px">{{ displayTotal(calculTotal(pricings)) }}</span>
            </div>
          </div>
        </div>

        <div *ngIf="codePromosActivated.length > 0">
          <div class="flexible width-100 toto mt-10" *ngFor="let code of codePromosActivated">
            <div class="flexible width-100">
              <div class="column flexible text-right width-100">
                <div class="total-title ft-16">Code promo: {{' '+code.name}}</div>
                <span class="price-2 width-10px" *ngIf="code.reduction_type === 'reduction_simple'">
                  {{'- ' + code.reduction_simple +' '+functionUtils.getPricingDeviseSymbole(devise)}}
              </span>
                <span class="price-2 width-10px" *ngIf="!(code.reduction_type === 'reduction_simple')">
                  {{'- ' + code.reduction_by_percentage+' %'}}
              </span>
              </div>
            </div>
          </div>
          <br>
        </div>

        <div class="flexible width-100 toto">
          <div class="flexible width-100">
            <div class="column flexible text-right width-100">
              <div class="total-title ft-16">{{'front_booking_infos.booking_fee'| translate}}</div>
              <span class="price-2 width-10px">{{displayTotal(fee) }}</span>
            </div>
          </div>
        </div>
        <div class="flexible width-100 toto">
          <div class="flexible width-100">
            <div class="column flexible text-right width-100">
              <div class="total-title ft-16">{{'front_booking_infos.total'| translate}}</div>
              <span class="price-2 width-10px text-green">{{ displayTotal(total())}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

  <div class="container">
   <div class="details-cmd" *ngIf="showLoginAndSignup()">
     <header class="flexible" style="padding: 30px!important;"></header>

     <div class="row" style="margin-top: 25px">
      <div class="booking-login-wrapper col-md-5 margin-bottom-50 rp-xs">
        <div style="text-align: center;margin-bottom: 20px">
         <h2 style="color: var(--btn-bgColor);">{{'front_booking_infos.booking'| translate}}</h2>
         <h5>{{'front_booking_infos.continue_as_guest'| translate}}</h5>
       </div>
        <app-pre-account-inputs (preAcount)="preAccount($event)"></app-pre-account-inputs>
     </div>

    <div class="col-md-2"></div>

    <div class="col-md-5 margin-bottom-50 rp-xs">
      <div style="text-align: center;margin-bottom: 20px">
        <h2 class="header-color">{{'front_booking_infos.quick_booking'| translate}}</h2>
        <h5>{{'front_booking_infos.log_in_for_a_faster_experience'| translate}}</h5>
      </div>
      <div *ngIf="isSignin">
        <app-login-form [isShoppingFunnel]="true" (logged)="recieveLoggenIn($event)" [displayLinks]="false"  [full]="true"></app-login-form>
      </div>
      <div *ngIf="isSignup">
        <app-signup-form [isShoppingFunnel]="true" (logged)="recieveLoggenIn($event)" [displayLinks]="false"  [full]="true"></app-signup-form>
      </div>
      <div *ngIf="isSignin" class="center">{{'front_booking_infos.no_account_yet'| translate}} <span  class="header-color underlined pointer" (click)="showSigup()">{{'front_booking_infos.register'| translate}}</span> </div>
      <div *ngIf="isSignup" class="center">Vous avez déja un compte? <span  class="header-color underlined pointer" (click)="showSignIn()">{{'front_booking_infos.connexion'| translate}}</span> </div>
    </div>
    </div>
   </div>
 </div>

  <div class="details-cmd" *ngIf="shoWBookingInputs()">

    <div class="container">

      <div *ngIf="!insCriptionMode && !event.has_open_ticketing && bookingGotMoreThanOneTicket(bookingLists)">
      <div style="text-align: center;margin-bottom: 26px;">
        <span style="color: var(--header-bgColor);font-size: 20px" *ngIf="!event.has_open_ticketing"> {{'front_booking_infos.you_have_bought_more_than_one_tickets_you_wish_to_send_them_by_email_to_your_friends'| translate}}</span>
        <span style="color: var(--header-bgColor);font-size: 20px" *ngIf="event.has_open_ticketing">{{'front_booking_infos.you_have_selected_several_participants_want_to_notify_them_by_email'| translate}}</span>
        <label>
          <span *ngIf="sendToFriends">{{'front_booking_infos.yes'| translate}}</span> <span *ngIf="!sendToFriends">{{'front_booking_infos.no'| translate}}</span>
          <input type="checkbox" value="{{sendToFriends}}" [checked]="sendToFriends" (change)="toggleSendToFriends($event)"   class="toggle-btn">
        </label>
      </div>

      <div style="text-align: center;font-size: 16px;margin-bottom: 10px" *ngIf="sendToFriends">
        <div>
          {{'front_booking_infos.once_the_order_is_complete_tickets_will_be_send_to_the_account_linked_to_the_email_addresses_indicated'| translate}}
          <br>
          {{'front_booking_infos.attention_each_ticket_is_valid_only_once'| translate}}
        </div>
      </div>
      </div>
     <div>
      <header class="flexible" *ngIf="!event.has_open_ticketing">
        <h5 class="inline-block text-uppercase">02. {{'front_booking_infos.buyer_data'| translate}}</h5>
        <a href="javascript:void(0);" title="Montrer/Cacher les détails" class="inline-block">
        </a>
      </header>

       <header class="flexible" *ngIf="event.has_open_ticketing">
         <h5 class="inline-block text-uppercase"> {{'front_booking_infos.jackpot_data'| translate}}</h5>
         <a href="javascript:void(0);" title="Montrer/Cacher les détails" class="inline-block">
         </a>
       </header>
      <div class="margin-bottom-50">
        <div class="width-100">
          <div class="" style="" *ngIf="locationCountryCode && event">
           <div class="embeded-info-data" *ngIf="embeded">
             {{'front_booking_infos.please_fill_out_the_requested_information'| translate}} <br>
             {{'front_booking_infos.You_may_be_asked_to_provide_proof_of_identity_upon'| translate}}
           </div>
           <div class="padding-10">
             <div class="padding-left-15">
               <div class="uneditable-input">
                 {{getUserCloe().firstname+' '+getUserCloe().lastname}}
               </div>
               <div class="padding-b-10">
                 {{getUserCloe().email}}
               </div>
             </div>
            <div class="row collapse padding-10 in show">
              <ng-container *ngFor="let input of order.Buyerinputs">
                <div class="col-md-6" *ngIf="!inputIsNotEditable(input)">
                  <div class="margin-bottom-20">
                    <app-registration-input [input1]="input" [event]="event"  [location]="locationCountryCode"></app-registration-input>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          </div>
        </div>
      </div>
     </div>

      <div *ngIf="ShowParticipantsData(bookingLists) && !insCriptionMode && !event.has_open_ticketing">

        <header class="flexible" >
          <h5 class="inline-block text-uppercase">03. {{'front_booking_infos.participants_data'| translate}}</h5>
          <a href="javascript:void(0);"  title="Montrer/Cacher les détails" class="inline-block">
          </a>
        </header>

        <div class="width-100">
          <div *ngFor="let booking of bookingLists let idx = index"  class="width-100">
            <div *ngIf="booking.tickets.length>0">
               <div class="table-header width-100">
                   <div class="">{{booking.Pricing_label}} <span class="opacity-50"></span></div>
               </div>
              <div class="" *ngFor="let ticket of booking.tickets let idx = index">
                <div class="" style="" *ngIf="locationCountryCode && event">
                  <a  data-toggle="collapse" style=""  href="#collapse{{ticket.id}}" aria-expanded="true" class="classCollapse padding-right-10 participant-label width-100" >{{showCheckParticipants(ticket)?participantName(ticket):'Participant'}}  {{ticket.id}} <i class="fa fa-check" *ngIf="showCheckParticipants(ticket)"></i></a>
                  <div class="">
                    <div class=" row collapse padding-10 show" id="collapse{{ticket.id}}">
                      <div class="col-md-6" *ngFor="let input of ticket.form.inputsTicket">
                        <div class="margin-bottom-20">
                          <app-registration-input [input1]="input" [event]="event" [location]="locationCountryCode"></app-registration-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!embeded">

        <div class="addons-wrapper" *ngIf="!insCriptionMode">

          <header *ngIf="!event.has_open_ticketing">{{'front_booking_infos.withdrawal_of_tickets'| translate}}</header>
          <header *ngIf="event.has_open_ticketing">{{'front_booking_infos.justificatory'| translate}}</header>

          <div class="addons-content flexible">
            <input type="checkbox" [checked]="billet" id="billetelectronique1" (change)="billet = !billet" [disabled]="true">
            <label  *ngIf="!event.has_open_ticketing">{{'front_booking_infos.electronik_ticket'| translate}}</label>
            <label  *ngIf="event.has_open_ticketing">{{'front_booking_infos.electronic_justificatory'| translate}}</label>
          </div>

          <div class="addons-content flexible" *ngIf="event.has_open_ticketing && 0">
            <input type="checkbox"  (change)="checkdonationReceipt($event)" [checked]="donation_receipt" >
            <label > <span class="text-italic">souhaitez vous recevoir un reçu</span>.</label>
          </div>

        </div>

        <div class="addons-wrapper" *ngIf="!insCriptionMode">
          <header class="text-uppercase">{{'front_booking_infos.terms_and_conditions'| translate}}</header>
          <div class="addons-content flexible" style="padding-bottom: 10px!important;" *ngIf="event.general_conditions_link || event.general_conditions_text">
            <input type="checkbox"  (change)="checkOrganizerCondition($event)" [checked]="organiserCondition" >
            <label>
              <span *ngIf="event.general_conditions_link" title="Conditions générales de l'organisateur" class="text-italic">En cochant cette case, je déclare avoir pris connaissance des conditions générales de <a  href="{{event.general_conditions_link}}" target="_blank" >{{event.general_conditions_link_name}}</a> </span>
              <span *ngIf="event.general_conditions_text"  title="Conditions générales de l'organisateur" class="text-italic">En cochant cette case, je déclare avoir pris connaissance des conditions générales de <a (click)="showCgu()">{{organiserName()}}</a></span>.
            </label>
          </div>
          <div class="addons-content flexible" >
            <input type="checkbox"  (change)="checkcondition($event)" [checked]="condition" >
            <label >{{'front_booking_infos.i_accept'| translate}} <a [routerLink]="['/cg']" target="_blank" title="{{'front_booking_infos.terms_and_conditions'| translate}}" class="text-italic">{{'front_booking_infos.terms_and_conditions'| translate}}</a>.</label>
          </div>
        </div>

        <div class="addons-wrapper" *ngIf="!event.has_open_ticketing">
          <div class="addons-content text-center">
            <label class="text-green text-uppercase">
              <i class="fa fa-info"></i>
              {{'front_booking_infos.a_piece_of_identity_can_be_claimed_at_the_entrance_of_the_event'| translate}}
            </label>
          </div>
        </div>

        <div class="text-right continue" style="margin-bottom: 35px;">
          <a (click)="continuer()" title="Continuer" id="continue" class="btn inline-block" style="color:#fff"> {{'front_booking_infos.continue'| translate}}</a>
        </div>

      </div>

      <div class="flex-space-between" *ngIf="embeded">
        <button class="frame_nav_btn" (click)="back()"> {{'front_booking_infos.back'| translate}}</button>
        <button class="frame_nav_btn frame-nav-next-btn"  (click)="continuer()" style="background-color: var(--btn-bgColor);"> {{'front_booking_infos.continue'| translate}}</button>
      </div>

      <div style="margin-bottom: 60px;" *ngIf="embeded">
        <div class="text-center" style="margin-bottom: 20px">
          <div>
            <li class="list-inline-item">
              <img src="assets/imgs/payment/visa.png" class="img-fluid" width="70" alt="..."/>
            </li>
            <li class="list-inline-item">
              <img src="assets/imgs/payment/mastercard.png" class="img-fluid" width="70" alt="..."/>
            </li>
            <div class="payment-icon__right">
              <img src="assets/imgs/payment/badge_secu.png" class="img-fluid" width="125" alt="..."/>
            </div>
          </div>
          <div style="margin-top: 13px">Powered by akces</div>
        </div>
      </div>
    </div>
  </div>
</div>
